import { render, staticRenderFns } from "./contacto.vue?vue&type=template&id=49d242f8"
import script from "./contacto.vue?vue&type=script&lang=js"
export * from "./contacto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports